// removed by extract-text-webpack-plugin
module.exports = {"this":"LayerTrigger__this___sYtC_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/styles/LayerTrigger.css
// module id = 1025
// module chunks = 4